<template>
  <GenericSupportModal>
    <template #trigger="{ open }">
      <BaseButton
        size="small"
        variant="ghost"
        @click="open"
      >
        <template #prepend>
          <QuestionMarkIcon />
        </template>
        <p
          class="kds-typography-interactive-medium kds-color-text-interactive-accent"
        >
          {{ $t('generic__help') }}
        </p>
      </BaseButton>
    </template>
  </GenericSupportModal>
</template>
<script setup>
import BaseButton from '@shared/components/BaseButton.vue'
import QuestionMarkIcon from '@shared/assets/icon/QuestionMarkIcon.vue'
import GenericSupportModal from '@us/app/components/GenericSupportModal.vue'
</script>

<style lang="scss" scoped></style>
